// Generic no-op shim for native modules with no web equivalent that are only
// *rendered* (or referenced) off the first-screen path. A recursive callable
// Proxy satisfies any shape — default import, named imports, X.y.z(), X() — and
// renders null as a React component.
function createNoop() {
  const fn = function () {
    return createNoop();
  };
  return new Proxy(fn, {
    get(_t, prop) {
      if (prop === "__esModule") return true;
      if (prop === "default") return root;
      if (prop === "then") return undefined; // not a thenable → no await-hang
      if (prop === Symbol.toPrimitive) return () => "";
      if (typeof prop === "symbol") return undefined;
      return createNoop();
    },
    apply() {
      return null; // valid null-rendering React element if used in JSX
    },
  });
}
const root = createNoop();
module.exports = root;
